import { SimpleGrid } from '@chakra-ui/react';
import { Field } from 'formik';

import { PartnerCodeField } from './PartnerCodeField';
import { TextField } from './TextField';

function RegistrationCodeFields({ values, resetMessages }) {
    const hasPartnerCode = Boolean(values.partnerCode);
    const hasApprovalCode = Boolean(values.approvalCode);
    const gridLabelStyles = {
        '& label': {
            marginRight: 0,
            '@media (min-width: 375px) and (max-width: 1536px)': {
                height: '48px',
            },
        },
    };

    // Don't render anything if neither code is present
    if (!hasPartnerCode && !hasApprovalCode) {
        return null;
    }

    const partnerCodeField = hasPartnerCode && (
        <Field
            name="partnerCode"
            onFocus={resetMessages}
            component={PartnerCodeField}
        />
    );

    const approvalCodeField = hasApprovalCode && (
        <Field
            name="approvalCode"
            onFocus={resetMessages}
            component={TextField}
            label="Approval Code"
            placeholder="Approval code"
            isReadOnly
        />
    );

    // Both codes: show in 2-column grid
    if (hasPartnerCode && hasApprovalCode) {
        return (
            <SimpleGrid
                columns={2}
                spacing={4}
                width="full"
                sx={gridLabelStyles}>
                {partnerCodeField}
                {approvalCodeField}
            </SimpleGrid>
        );
    }

    // Single code: no grid needed, stack normally
    return (
        <>
            {partnerCodeField}
            {approvalCodeField}
        </>
    );
}

export { RegistrationCodeFields };
